module.exports = __webpack_public_path__ + "static/img/pic_title.c36bd74.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/pic_title.png
// module id = E4Vv
// module chunks = 108